import { observable, computed, action } from "mobx";
//import { ROUTE_FROM_PEGNI, ROUTE_RICEVUTE, ROUTE_RICEVUTE_DETTAGLIO } from "../assets/frontendRouting";
import {  PATH_TIPOLOGICHE, PATH_DOWNLOAD_FILE_PEGNO, PATH_RICHIESTA_DUPLO } from "../config/presdoc-fe-config";

class RichiestaDuploStore {

  constructor(root) {   
    this.service = root.service
    this.serviceDownload = root.serviceDownload;
    this.userInfoStore = root.userInfoStore;
    this.qualificheStore= root.qualificheStore;
    this.routingStore = root.routingStore;
  }

  @observable loading = false;
  @observable esitoPositivo = undefined;
  @observable descErrore = undefined;
  
  
 
 

  richiesta(params){
    this.loading = true;
    params.cfUtente = this.userInfoStore.userInfo.codiceFiscale;
    this.serviceDownload.doAjax('POST', `${PATH_RICHIESTA_DUPLO}`, params)  
    .then(response => {  
      this.loading = false;
      if(response.success) {
        //console.log("sono dentro if" + response.result)
          this.esitoPositivo= response.result.codEsito === 0 ?true:false;
          //console.log("this.codEsito"+this.codEsito)
          if(!this.esitoPositivo){
            this.descErrore = response.result.descErrore;
          }
        }
        this.loading = false;
      });
      
    //console.log(params)
    
  }

  reset(){
    this.esitoPositivo = undefined;
    this.descErrore = undefined;
  }



 }

export default RichiestaDuploStore;